import './ApiSentry.scss';
import { useState } from 'react';
import { Page } from '@Components/Page';
import { AdminDashboard } from './admin/AdminDashboard';
import { ChangesDashboard } from './components/ChangesDashboard';

const ApiSentryTab = {
  DASHBOARD: 'dashboard',
  ADMIN: 'admin'
} as const;
type ApiSentryTabType = (typeof ApiSentryTab)[keyof typeof ApiSentryTab];

const NAVS = [
  { key: ApiSentryTab.DASHBOARD, label: 'Changes' },
  { key: ApiSentryTab.ADMIN, label: 'Admin' }
];

const ApiSentry = () => {
  const [activeTab, setActiveTab] = useState<ApiSentryTabType>(ApiSentryTab.DASHBOARD);

  return (
    <Page
      pageType='API Sentry'
      title='API Sentry'
      navs={NAVS}
      selectedNav={activeTab}
      onNav={key => setActiveTab(key as ApiSentryTabType)}
    >
      <div className='api-sentry-page'>
        {activeTab === ApiSentryTab.ADMIN ? <AdminDashboard /> : <ChangesDashboard />}
      </div>
    </Page>
  );
};

export { ApiSentry };
